module.exports = __webpack_public_path__ + "static/rain3-c8d05f4823bcc4827453133c08f8a354.png";